import { Form, Formik } from "formik";
import React, { useState } from "react";
import FormField from "../../components/form-field";
import { useAuth } from "../../context/AuthContext";
import * as Yup from "yup";

const LoginPage = () => {
  const { signIn } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email address").required("Required"),
    password: Yup.string().min(6, "Password must be at least 6 characters").required("Required"),
  });

  return (
    <div className="h-dvh flex items-center justify-center">
      <div
        className="p-10 px-3 lg:px-10 m-auto border-gray-200 shadow-md rounded-lg w-10/12 md:w-8/12 xl:w-1/3"
        style={{ borderWidth: "1px" }}
      >
        <div className="flex items-center justify-center flex-col mb-9">
          <h1 className="text-black font-bold text-3xl">Sign in</h1>
        </div>
        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            setIsLoading(true);
            await signIn(values.email, values.password);
            setIsLoading(false);
            setSubmitting(false);
          }}
        >
          {({ isValid }) => (
            <Form className="space-y-4">
              <FormField
                htmlFor="email"
                label="Email"
                id="email"
                name="email"
                placeholder="Email"
                type="email"
              />
              <FormField
                htmlFor="password"
                label="Password"
                id="password"
                name="password"
                placeholder="Password"
                type="password"
              />
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    id="checked-checkbox"
                    type="checkbox"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label
                    htmlFor="checked-checkbox"
                    className="ms-2 text-sm font-medium text-gray-900"
                  >
                    Keep me logged in
                  </label>
                </div>
                <p className="text-blue-600 hover:underline cursor-pointer text-sm lg:text-lg">
                  Forgot password?
                </p>
              </div>
              <div>
                <button
                  type="submit"
                  disabled={!isValid || isLoading}
                  className={`p-2 rounded w-full mt-10 flex items-center justify-center gap-2
                    ${
                      !isValid || isLoading
                        ? "bg-blue-300 text-white cursor-not-allowed"
                        : "bg-blue-500 text-white hover:bg-blue-600 cursor-pointer"
                    }`}
                >
                  {isLoading ? (
                    <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                  ) : (
                    "Sign In"
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default LoginPage;
